import { Alert, Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

// components
import { AreaList } from "./area-list";
import { LoaderMUI } from "../../../assets/global/loader/loader-mui";
import { AlertMessage } from "../../../assets/global/alert/alert-message";
import { AreaProgressBar } from "./area-progress-bar";
import { TutorialPopupPlanner } from "../../tutorials/tutorial-popup-planner";
import { ViewOnlyMsg } from "../../layout/view-only-msg";

// services & utils
import { luckyorangeTrackEven } from "../../../services/lucky-orange/luckyorange-events";
import { useAppContext } from "../../../services/context/app-context";
import { axiosInstance } from "../../../services/api/api";
import { usePlannerContext } from "../../../services/context/planner-context";
import { calculateBuildingMetrics } from "../../../utils/planner";
import { useUserContext } from "../../../services/context/user-context";

// constants
import { AREA_RATIO } from "../../../constants/global.constants";
import { TEXT } from "../../../constants/text";
import { COLORS_GLOBAL } from "../../../constants/colors.constants";

// svg
import { ReactComponent as IconInformation } from "../../../assets/svg/information.svg";
import { ReactComponent as IconArrowLeft } from "../../../assets/svg/arrow-left.svg";

// style
import "./sidebar-planner.css";

export const SidebarPlanner = ({}) => {
  const {
    validateStart,
    setValidateStart,
    validateEnd,
    setValidateEnd,
    errors,
    setErrors,
    nodes,
    property,
  } = usePlannerContext();
  const { viewOnly } = useUserContext();
  const navigate = useNavigate();
  const { projectId, companyId } = useParams();
  const [searchParams] = useSearchParams();
  const userToken = searchParams.get("token");

  const { userData } = useUserContext();

  const areaRule = userData.isAdmin ? 100 : AREA_RATIO;

  const [errorInputs, setErrorInputs] = useState(null);
  const [errorMissingParts, setErrorMissingParts] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isAdminBtn, setIsAdminBtn] = useState(false);

  const goToMainPage = () => {
    navigate(
      `/company/${companyId}/project/${projectId}/map/results?token=${userToken}`
    );
  };

  const nodesLength = nodes ? nodes.length : 0;

  const { buildingAreaSum, maxInnerBuildHeight } =
    calculateBuildingMetrics(nodes);

  const propertyArea = property ? property.area : 0;

  const areaRation = (buildingAreaSum / propertyArea) * 100;

  const handleGenerateBtn = (isAdmin) => {
    luckyorangeTrackEven("Planner: generate result");
    setValidateStart((prev) => prev + 1);
    setErrors(0);
    setValidateEnd(0);
    /* setLoading(true); */
    setErrorInputs(null);
    if (nodes.length === 0) {
      setErrorMissingParts("Please add at least one function type.");
    } else {
      setErrorMissingParts(null);
    }
    /* setIsAdminBtn(isAdmin); */
    // API generate planner
  };

  const startGeneration = async () => {
    setLoading(true);
    try {
      /* const response = await axiosInstance.get(
        `/runner2/${isAdminBtn ? "startAdmin" : "start"}/${projectId}`
      ); */
      const response = await axiosInstance.get(`/runner2/start/${projectId}`);
    } catch (error) {
      // Handle error
    } finally {
      setLoading(false);
      goToMainPage();
    }
  };

  useEffect(() => {
    if (validateStart > 0 && validateEnd > 0) {
      if (errors > 0 || (property && areaRation > areaRule)) {
        setErrorInputs(true);
      } else {
        setErrorInputs(false);
        if (property && nodes && nodes.length > 0) {
          setErrorMissingParts(null);
          startGeneration();
        } else if (property && nodes.length === 0) {
          setErrorMissingParts("Please add at least one function type.");
        } else if (!property && nodes.length > 0) {
          setErrorMissingParts("Please go to Site Settings and create a site.");
        } else {
          setErrorMissingParts(
            "Please go to Site Settings and create a site. Also, add at least one function type."
          );
        }
      }
    }

    /* setLoading(false); */
  }, [validateEnd]);

  return (
    <>
      {/* Loader */}
      {loading && <LoaderMUI withBackdrop={true} />}

      {/* Error Alert */}

      {/* Success Alert */}
      {/* showApiAlert && <AlertMessage message={'Property saved'} type="success" /> */}

      <Box
        className="sidebar-planner"
        sx={{
          width: "320px",
          height: "calc(100% - 80px - 74px)", // 80px -top, 74px - bottom
          background: "#FBFBFD",
          borderRadius: "16px",
          position: "absolute",
          top: "80px",
          left: "16px",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          /* alignItems: 'center', */
          justifyContent: "space-between",
          boxShadow: 3,
        }}
      >
        <Box
          sx={{
            flexGrow: 0,
            display: "flex",
            height: "calc(100% - 68.5px)", // btn area height
            width: "100%",
            flexDirection: "column",
          }}
        >
          {viewOnly && <ViewOnlyMsg />}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "16px",
            }}
          >
            <Typography noWrap flexShrink={0} fontSize={24} fontWeight={700}>
              Function Type
            </Typography>
            <TutorialPopupPlanner nodesLength={nodesLength} />
          </Box>

          <AreaList />
          <Box sx={{ display: "flex", p: "16px", alignItems: "flex-start" }}>
            <Box>
              <IconInformation fill="#5D5F6A" width="24px" height="24px" />
            </Box>

            <Typography sx={{ fontSize: "12px", color: "#777982", ml: "8px" }}>
              {TEXT.planner.tooltip}
            </Typography>
          </Box>
          {property && (
            <AreaProgressBar
              buildingAreaSum={buildingAreaSum}
              propertyArea={propertyArea}
            />
          )}
          {/* {maxInnerBuildHeight > 0 &&
            maxInnerBuildHeight > Number(property.maxConstrHeight) && (
              <Box
                sx={{
                  width: "100%",
                  position: "relative",
                  margin: "0 auto",
                  padding: "0 16px 16px 16px",
                }}
              >
                <Alert
                  severity={"error"}
                  sx={{ width: "100%", fontSize: "12px" }}
                >
                  The minimum inner clearance height in one or more buildings
                  exceeds the maximum construction height. Please adjust the
                  values.
                </Alert>
              </Box>
            )} */}
          {errorInputs && (
            <Box
              sx={{
                width: "100%",
                position: "relative",
                margin: "0 auto",
                padding: "0px 16px 16px 16px",
              }}
            >
              <Alert
                severity={"error"}
                sx={{ width: "100%", fontSize: "12px" }}
              >
                Unable to generate results. Please correct the highlighted
                errors and try again.
              </Alert>
            </Box>
          )}
          {errorMissingParts && (
            <Box
              sx={{
                width: "100%",
                position: "relative",
                margin: "0 auto",
                padding: "0px 16px 16px 16px",
              }}
            >
              <Alert
                severity={"error"}
                sx={{ width: "100%", fontSize: "12px" }}
              >
                {errorMissingParts}
              </Alert>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              gap: "16px",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Button
              sx={{
                width: "50%",
                background: "#fff",
                color: "#343745",
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                boxShadow: 2,
                ":hover": {
                  boxShadow: 4,
                },
              }}
              onClick={goToMainPage}
            >
              <IconArrowLeft
                stroke="#5d5f6a"
                /*  strokeWidth={"2px"} */
                width={"18px"}
                height={"18px"}
              />
              Results
            </Button>
            <Button
              sx={{
                width: "100%",
                background: "#EFA21E",
                color: "#fff",
                textTransform: "none",
                boxShadow: 2,
                ":disabled": {
                  color: COLORS_GLOBAL.BTN_DISABLED,
                  background: COLORS_GLOBAL.BTN_DISABLED_BG,
                },
                ":hover": {
                  boxShadow: 4,
                },
              }}
              onClick={() => handleGenerateBtn(false)}
              disabled={viewOnly}
            >
              Generate Results
            </Button>

            {/*  <Button
              sx={{
                width: "100%",
                background: "#343745",
                color: "#fff",
                textTransform: "none",
                boxShadow: 2,
                ":disabled": {
                  color: "#C7C7D6",
                  background: "#EEEEF6",
                },
                ":hover": {
                  boxShadow: 4,
                },
              }}
              onClick={handleSaveBtn}
            >
              Save
            </Button> */}
          </Box>
          {/* {role === "admin" && (
            <Button
              sx={{
                width: "100%",
                background: "#EFA21E",
                color: "#fff",
                textTransform: "none",
                boxShadow: 2,
                ":disabled": {
                  color: "#C7C7D6",
                  background: "#EEEEF6",
                },
                ":hover": {
                  boxShadow: 4,
                },
              }}
              onClick={() => handleGenerateBtn(true)}
            >
              Generate Results Admin
            </Button>
          )} */}
        </Box>
      </Box>
    </>
  );
};
